module.exports = __webpack_public_path__ + "static/media/bar-code.65d05fcf.svg";